import React from 'react';

function TextLabel({ text }) {

    return (
         <label className="form-label">{text ?? ""}</label>
    );
}

export default TextLabel;